import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary' | 'white';
  className?: string;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  variant = 'primary',
  className = '',
  text
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const variantClasses = {
    primary: 'border-primary',
    secondary: 'border-muted-foreground',
    white: 'border-white'
  };

  const spinnerClass = `
    animate-spin rounded-full border-2 border-t-transparent
    ${sizeClasses[size]}
    ${variantClasses[variant]}
    ${className}
  `.trim();

  if (text) {
    return (
      <div className="flex flex-col items-center justify-center gap-3">
        <div className={spinnerClass} />
        <p className="text-sm text-muted-foreground">{text}</p>
      </div>
    );
  }

  return <div className={spinnerClass} />;
};

export default LoadingSpinner;